import { combineReducers } from 'redux';
import * as types from './actionTypes';
import constants from '../constants';
import util from '../util';

const baseReducer = util.requestReducer(types.WIDGET_CONFIG);

const widgetConfigReducer = (state = util.requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.UPDATE_WIDGET_CONFIG_REQUEST:
      return state
        .set(constants.FETCHING_KEY, true)
        .set(constants.ERROR_KEY, null);
    case types.UPDATE_WIDGET_CONFIG_SUCCESS:
      return state
        .set(constants.DATA_KEY, payload)
        .set(constants.FETCHING_KEY, false);
    case types.UPDATE_WIDGET_CONFIG_FAILURE:
      return state
        .set(constants.ERROR_KEY, payload)
        .set(constants.FETCHING_KEY, false);
    default:
      return baseReducer(state, action);
  }
};

export default combineReducers({
  config: widgetConfigReducer,
});
